import type { Company, TagAttributeDto } from "~/types/api";
import { BaseAPI, type ApiResponse } from "./base";
import type { CompanySettings } from "~/utils/api-util";
import { distinctBy } from "~/utils/array-util";

export class CompanyApi extends BaseAPI {
  async getCompanies(): Promise<ApiResponse<Company[]>> {
    return this.get<Company[]>(`companies/all`);
  }

  async settings(): Promise<ApiResponse<CompanySettings>> {
    return this.get<CompanySettings>(`settings/company/${this.company()}`);
  }

  async settingsUpdate(data: CompanySettings): Promise<ApiResponse<null>> {
    return this.put<null>(`settings/company/${this.company()}`, data);
  }

  async attributes(): Promise<ApiResponse<TagAttributeDto[]>> {
    let resp = await this.get<TagAttributeDto[]>(
      `tag/company/${this.company()}/attributes`,
    );

    if (!resp.ok) return resp;

    resp.data = distinctBy(resp.data ?? [], (a) => a.normalizedName);
    return resp;
  }
}
